module.exports = __webpack_public_path__ + "static/schemat-gphe-00e042e1a93f0e19b290cfbfbe0f875a.png";